// DO NOT EDIT: Code generated at build time.

import { ReferrerConfiguration } from '@preventx/prismic-services';

export const referrers: ReferrerConfiguration[] = [

]
  